import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';

import {
    Select,
    ToggleSwitch,
} from '../../../Form';
import { allowedMatchTimes } from '../../../../utils/allottedTimeConstants';
import Img from '../../../Img';
import { required, validateEventAllottedMatchTimeScoringFormat } from '../../../../utils/validation';

const EventAllottedMatchTimes = (props) => {
    const {
        field,
        formApi,
        eventAllottedMatchTimesField,
        eventAllottedMatchTimesValue,
        sportTypeId,
    } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);

    const { scoringTypes = [] } = coreUI.types?.tms?.division?.tournament || {};

    const canDelete = (index) => {
        return eventAllottedMatchTimesValue?.length > 1 && (index < eventAllottedMatchTimesValue?.length - 1);
    };

    const canAdd = (index) => {
        return index === eventAllottedMatchTimesValue.length - 1;
    };

    const onDelete = (index) => () => {
        eventAllottedMatchTimesValue.splice(index, 1);
        formApi.setValue(eventAllottedMatchTimesField, eventAllottedMatchTimesValue);
    };

    const onAdd = () => {
        formApi.setValue([eventAllottedMatchTimesField, eventAllottedMatchTimesValue?.length], {});
    };

    const selectableScoringTypes = scoringTypes.filter(type => {
        return type.sportTypeId === sportTypeId;
    });

    const onCheckChange = (val) => {
        if (!val) {
            formApi.setValue(eventAllottedMatchTimesField, []);
            formApi.setError(eventAllottedMatchTimesField, null);
        } else {
            formApi.setValue(eventAllottedMatchTimesField, [{}]);
        }
    };

    const onChangeScoringType = (index) => (scoringTypeId) => {
        // Set default time received from types all
        const scoringType = scoringTypes.find((sType) => {
            return sType.id === parseInt(scoringTypeId);
        });

        if (scoringType) {
            formApi.setValue([eventAllottedMatchTimesField, index, 'allottedMatchTime'], scoringType.allottedMatchTime);
        }
    };

    return (
        <div className={`col-12 mb24`}>
            <ToggleSwitch
                id={'hasEventScoringFormats'}
                field={field}
                formGroupCssClass={`mt16`}
                label="Add scoring formats allotted times"
                onChange={onCheckChange}
                reverse={false}
            />
            {eventAllottedMatchTimesValue?.length > 0 && eventAllottedMatchTimesValue.map((scoringFormat, index) => {
                return (
                    <div className="d-flex align-items-start mb16" key={`match-time-${index}`}>
                        <div className="flex-1">
                            <Select
                                id={`${eventAllottedMatchTimesField}${index}scoringTypeId`}
                                formGroupCssClass={`mb0`}
                                field={[eventAllottedMatchTimesField, index, 'scoringTypeId']}
                                options={selectableScoringTypes}
                                label="Scoring format"
                                validate={(e) => validateEventAllottedMatchTimeScoringFormat(e, eventAllottedMatchTimesValue)}
                                onChange={onChangeScoringType(index)}
                            />
                        </div>
                        <div className="ml16 flex-1">
                            <Select
                                id={`${eventAllottedMatchTimesField}${index}allottedMatchTime`}
                                formGroupCssClass={`mb0`}
                                field={[eventAllottedMatchTimesField, index, 'allottedMatchTime']}
                                options={allowedMatchTimes}
                                label="Allotted time"
                                validate={required}
                            />
                        </div>
                        {canDelete(index) && (
                            <button
                                className="ml16 mt32 btn btn-post"
                                type="button"
                                onClick={onDelete(index)}
                            >
                                <Img src={'/img/v3/icons/icon-trash-red.svg'} />
                            </button>
                        )}
                        {canAdd(index) && (
                            <button
                                className="ml16 mt24 btn btn-post"
                                type="button"
                                onClick={onAdd}
                            >
                                <Img src={'/img/v2/icons/icon-create-play-blue.svg'} />
                            </button>
                        )}
                    </div>
                );
            })}
            <div className="div div16" />
        </div>
    );
};

EventAllottedMatchTimes.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    eventAllottedMatchTimesField: PropTypes.string.isRequired,
    eventAllottedMatchTimesValue: PropTypes.arrayOf({
        id: PropTypes.string,
        scoringType: PropTypes.number.isRequired,
        allottedMatchTime: PropTypes.number.isRequired,
    }).isRequired,
    sportTypeId: PropTypes.number.isRequired,
};

export default EventAllottedMatchTimes;
